<template>
  <section
    class="highlight-list">
    <div
      v-for="(row, key) in rows"
      :key="`highlight-row${key}`"
      class="row">
      <h1 v-html="row.heading"></h1>
      <ul class="row__list">
        <li
          v-for="(highlight, key) in  row.highlights"
          :key="`highlight${key}`"
          class="row__list-item">
          <p v-html="highlight.text"></p>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HighlightList',
  props: {
    rows: {
      type: Array,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.highlight-list {
  width: 100%;

  .row {
    display: flex;
    margin: 0 0 $page-padding 0;
    h2, h1 {
      width: 50%;
      color: $dk-grey;
    }

    &__list {
      width: 50%;

      &-item {
        padding: 0 0 0 1.5rem;
        margin: 0 0 $page-padding 0;
        position: relative;
        &:before {
          content: '•';
          position: absolute;
          left: 2px;
          top: 4px;
        }
      }
    }
  }

  @media screen and (max-width: $mobile) {
    .row {
      flex-direction: column;
      margin: 0 0 $page-padding 0;

      h1, h2, &__list {
        width: 100%;
      }
    }
  }
}
</style>
